import createFields from './createFields';
import plain from './structure/plain';
export default createFields(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/Fields.js
// module id = 1009
// module chunks = 0